import React, { useRef } from 'react';
import ReactDOM from 'react-dom';

type Props = {
  children: React.ReactNode;
};

const Portal = ({ children }: Props) => {
  // #react-modal-container is located in app_base.html in the body element
  const portalContainer = useRef(document.getElementById('react-portal-container')!);
  return ReactDOM.createPortal(children, portalContainer.current);
};

export default Portal;
